export type LaunchToolDto = {
        id: string,
        userId: string,
        courseCode:string,
        firstName: string,
        lastName: string,
        email: string,
        createdAt: Date,
        refreshedAt: Date,
        custom:any,
        targetLinkURI:string
}

export const TestUser :LaunchToolDto ={
          "id": "test-abc-request-uuid",
          "userId": "test-user-uuid",
          "courseCode": "",
          "firstName": "test",
          "lastName": "test",
          "email": "lti-platform-test-user@relias.de",
          "createdAt": new Date(),
          "refreshedAt": new Date(),
          "custom":"",
          "targetLinkURI":""
}